import { MediaObject } from 'foundations-components/transitional/components/MediaObject';
import TagsShowMore from './TagsShowMore';
import FormattedPropertyV2 from 'customer-data-properties/formatted/FormattedPropertyV2';
import { useCallback } from 'react';
import getIn from 'transmute/getIn';
import { parseMultiEnumValue } from 'customer-data-property-utils/parseMultiEnumValue';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const TagWrapper = styled.span.withConfig({
  displayName: "Tags__TagWrapper",
  componentId: "sc-1sgwp17-0"
})(({
  theme
}) => `
  .tag {
    margin-left: ${theme.space['0']};
    margin-right: ${theme.space['100']};
  }
`);
const Tags = ({
  tags,
  object,
  objectTypeDef,
  isCompact
}) => {
  const getAdditionalPropertyValue = useCallback(propertyName => getIn(['properties', propertyName, 'value'], object), [object]);
  if (isCompact) {
    const firstTagValue = parseMultiEnumValue(tags.value)[0];
    return /*#__PURE__*/_jsx(MediaObject, {
      itemRight: /*#__PURE__*/_jsx(TagsShowMore, {
        tags: tags,
        object: object,
        objectTypeDef: objectTypeDef
      }),
      children: /*#__PURE__*/_jsx(FormattedPropertyV2, {
        objectTypeId: objectTypeDef.objectTypeId,
        objectId: `${object.objectId}`,
        property: tags.definition,
        value: firstTagValue,
        getAdditionalPropertyValue: getAdditionalPropertyValue
      })
    });
  }
  return /*#__PURE__*/_jsx(TagWrapper, {
    children: /*#__PURE__*/_jsx(FormattedPropertyV2, {
      objectTypeId: objectTypeDef.objectTypeId,
      objectId: `${object.objectId}`,
      property: tags.definition,
      value: tags.value,
      getAdditionalPropertyValue: getAdditionalPropertyValue
    })
  });
};
export default Tags;